import React from 'react';
import { Button, Grid, Typography, makeStyles } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import Modal from '../common/Modal';
import InsightScreen from './InsightScreen';
import Hubspot from './Hubspot';

const useStyles = makeStyles(() => ({
  insightspopup: {
    display: 'flex',
  },
  heading: {
    width: '100%',
    height: '50px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

export const InsightPopup = ({
  PERIOD_ARR,
  INSIGHT_TABS,
  timePeriod,
  setTimePeriod,
  selctedDealerId,
  appliedFilters,
  setAppliedFilters,
  setOpenInsightPopup,
}) => {
  const classes = useStyles();
  return (
    <Modal isOpen height="80vh" width="80vw">
      <Grid container className={classes.insightspopup}>
        <Grid className={classes.heading}>
          <Typography variant="h6">Dealership Insights</Typography>
          <Button onClick={() => setOpenInsightPopup(false)}>
            <Close style={{ fontSize: '32px' }} />
          </Button>
        </Grid>

        <Grid container style={{ display: 'flex', height: '90%', width: '100%' }}>
          <InsightScreen
            PERIOD_ARR={PERIOD_ARR}
            INSIGHT_TABS={INSIGHT_TABS}
            timePeriod={timePeriod}
            setTimePeriod={setTimePeriod}
            selctedDealerId={selctedDealerId}
            appliedFilters={appliedFilters}
            setAppliedFilters={setAppliedFilters}
          />
          <Hubspot selctedDealerId={selctedDealerId} />
        </Grid>
      </Grid>
    </Modal>
  );
};
